/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Heading/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'



/** @type {import('Simple/types.js').View} */
export default function Heading({
  children,
  viewPath = "/DesignSystem/DataVaxiomProfessionalView/Content/Email/Heading"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 display="block"
 marginBottom={dtSpaceS}
 level="h4"
 text="Emails"
 color={dtColorsNeutral400}
/>
{children}
</React.Fragment>)
}